<template>
  <div class="container bg1">
    <h3>Add new user</h3>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <form v-on:submit.prevent>
          <div class="form-group">
            <label for="name">First name:</label>
            <input
              class="form-control"
              type="text"
              placeholder="Name"
              v-model="newUser.first_name"
              id="firstname"
            >
          </div>
          <div class="form-group">
            <label for="name">Last name:</label>
            <input
              class="form-control"
              type="text"
              placeholder="Name"
              v-model="newUser.last_name"
              id="lastname"
            >
          </div>
          <div class="form-group">
            <label for="email">Email address:</label>
            <input
              class="form-control"
              type="email"
              placeholder="Email"
              v-model="newUser.email"
              id="email"
            >
          </div>
          <div class="form-group">
            <label for="phone">Phone Number :</label>
            <input
              class="form-control"
              type="text"
              placeholder="Phone no."
              v-model="newUser.phone"
              id="phone"
            >
          </div>
          <div class="form-group">
            <label for="pass">Password:</label>
            <input
              class="form-control"
              type="text"
              placeholder="Password"
              v-model="newUser.password"
              id="pass"
            >
          </div>
          <button
            class="pa-3 admin_button"
            @click="addUser"
          >Add User</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import lb from "../../util/lb";
  import { mapGetters } from "vuex";

  export default {
    name: "AddNewUser",
    computed: {
      ...mapGetters(["user"])
    },
    data() {
      return {
        newUser: {
          first_name: null,
          last_name: null,
          email: null,
          password: null,
          phone: null
        }
      };
    },
    mounted() {
      if (!this.user) {
        this.$router.push("/login");
        return;
      }
      if (this.user.admin != 999) {
        this.$router.push("/myaccount");
        return;
      }
    },
    methods: {
      addUser() {
        //   if(validation){}
        lb.post("/api/GWSUsers", {
          first_name: this.newUser.first_name,
          last_name: this.newUser.last_name,
          email: this.newUser.email,
          phone: this.newUser.phone,
          password: this.newUser.password,
          admin: 0
        })
          .then(() => {
            this.$toasted.show("User Added", {
              duration: 2000,
              position: "bottom-right"
            });
            this.newUser = {
              first_name: null,
              last_name: null,
              email: null,
              password: null,
              phone: null
            };
          })
          .catch(e => {
            this.$toasted.error(e.message || "Some error occured!", {
              duration: 2000,
              position: "bottom-right"
            });
          });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .admin_button {
    color: #fff;
    width: 100%;
    background-color: #31cc9a;
  }
  h3 {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/AddNewUser.vue